import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, IconButton, Icon, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import Avatar from '../../../../sharedComponents/Avatar';
import { FeatureToggle } from '../FeatureToggle';
import { BackBlackIcon } from '../../../../sharedComponents/Icons';
import styles from './MoreMenu.styles';

const useStyles = makeStyles(styles);

const MoreMenuItem = ({
  onClick,
  title,
  toggle,
  quantity,
  showArrow,
  showCircle,
  showQuantity,
  classMenu,
  arrowClass,
  moreIcon,
  divider,
  icon = '',
  ...props
}) => {
  const classes = useStyles();
  const DisplayIcon = icon;
  const renderItem = () => (
    <>
      <ListItem onClick={onClick} button {...props}>
        {showCircle && <Avatar className={classes.avatarIconStyle}> {icon && <DisplayIcon />}</Avatar>}
        <ListItemText primary={title} classes={{ primary: classMenu || classes.menuText }} />

        {showQuantity && (
          <Typography variant="body1" className={classes.quantity} data-testid="menu-name">
            {quantity}
          </Typography>
        )}
        {showArrow && (
          <IconButton edge="end" color="inherit" aria-label="arrow" data-testid="menu-button">
            <Icon component={BackBlackIcon} className={cx(classes.categoryArrow, arrowClass)} fontSize="small" />
          </IconButton>
        )}
        {moreIcon}
      </ListItem>
      {divider && <Divider variant="middle" />}
    </>
  );

  return toggle ? (
    <FeatureToggle feature={toggle}>{(isEnabled) => isEnabled && renderItem()}</FeatureToggle>
  ) : (
    renderItem()
  );
};

MoreMenuItem.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  toggle: PropTypes.string,
  showCircle: PropTypes.bool,
  arrowClass: PropTypes.string,
};

MoreMenuItem.defaultProps = {
  title: '',
  onClick: () => {},
  showCircle: true,
};

export default MoreMenuItem;
